import Layout from "../../../../Layout/Layout";
import { router } from "@inertiajs/react";
import UidMigrationWizard from "../../../../Components/UidMigrationWizard";

export default function IntakePageFive({ participant }) {
  return (
    <>
      <Layout title="New Participant Intake Form">
        <div className="flex flex-col flex-wrap w-full p-8 mt-4 bg-white shadow-md md:p-16">
          <h5 className="mb-4 text-2xl font-semibold text-gray-700">
            Confirm participant ID
          </h5>
          <UidMigrationWizard
            mode="intake"
            participant={participant}
            onCancel={() => router.visit("/participants/create4")}
          />
        </div>
        <div className="flex flex-row flex-wrap items-center w-full px-8 space-y-4 bg-customBlue md:space-x-4 md:space-y-0 py-7 md:px-16">
          <div className="flex-col items-center w-full py-2 bg-white rounded-full md:flex-row md:w-auto">
            <div className="flex flex-row items-center px-4">
              <small className="pr-2">Step 5 of 5</small>
              <div className="w-4 h-4 rounded-full bg-customBlue"></div>
              <div className="w-2 h-1 bg-gray-300"></div>
              <div className="w-4 h-4 rounded-full bg-customBlue"></div>
              <div className="w-2 h-1 bg-gray-300"></div>
              <div className="w-4 h-4 rounded-full bg-customBlue"></div>
              <div className="w-2 h-1 bg-gray-300"></div>
              <div className="w-4 h-4 rounded-full bg-customBlue"></div>
              <div className="w-2 h-1 bg-gray-300"></div>
              <div className="w-4 h-4 rounded-full bg-customBlue"></div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}
